var $class="se2--content-product-blocks",$name="ContentProductBlocks",$path="app/components/ContentProductBlocks/config.js",$this={$class,$name,$path,};export const slideDuration = 0.3;
export const defaultSlideIndex = 0;
export const nextButtonSelector = '.button-next';
export const prevButtonSelector = '.button-prev';
export const slideSelector = '.slide';
export const cardsContainerClassName = 'cards-container';
export const cardsContainerSelector = `.${cardsContainerClassName}`;
export const controlsSelector = '.controls';
